<template>
  <generic-modal
    size="large"
    :title="$t('archeology pieces configuration')"
    icon="quidditch"
    image="/images/icons/archeology.jpg"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui top attached tabular menu">
        <a class="active item" data-tab="catalogs">{{ $t("catalogs") }} </a>
        <a class="item" data-tab="security">{{ $t("security") }}</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="catalogs">
        <div class="ui two column grid">
          <div class="column">
            <generic-catalog
              :title="$t('cultural area')"
              :attributes="catalogs.cultural_area"
            />
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('cultural sub-area')"
              :attributes="temp.cultural_subarea"
            >
              <div class="field">
                <label for>{{ $t("select cultural area") }}</label>
                <div class="ui selection dropdown" ref="cultural_area_dropdown">
                  <input type="hidden" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
            </generic-catalog>
          </div>
          <div class="column">
            <generic-catalog :title="$t('region')" :attributes="temp.region">
              <div class="field">
                <label for>{{ $t("select cultural sub-area") }}</label>
                <div
                  class="ui selection dropdown"
                  ref="cultural_sub_area_dropdown"
                >
                  <input type="hidden" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
            </generic-catalog>
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('temporality')"
              :attributes="temp.temporality"
            >
              <div class="field">
                <label for>{{ $t("select region") }}</label>
                <div class="ui selection dropdown" ref="region_dropdown">
                  <input type="hidden" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
            </generic-catalog>
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('motives')"
              :attributes="catalogs.motive"
            />
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('style')"
              :attributes="catalogs.style"
            />
          </div>
          <!-- <div class="column">
          <generic-catalog
            :title="$t('deposit')"
            :attributes="catalogs.deposit"
          />
        </div>-->
          <div class="column">
            <generic-catalog
              :title="$t('support')"
              :attributes="catalogs.support"
            />
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="security">
        <security ref="security_component" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericCatalog from "../ArcheologyConfigureCatalog";
import Security from "./Security.vue";

export default {
  name: "ArcheologyConfigureModal",
  components: {
    "generic-modal": GenericModal,
    GenericCatalog,
    Security,
  },
  computed: {},
  data() {
    return {
      catalogs: {
        cultural_area: [],
        temporality: [],
        motive: [],
        style: [],
        support: [],
        cultural_subareas: [],
        regions: [],
      },
      temp: {
        cultural_subarea: [],
        region: [],
        temporality: [],
      },
    };
  },
  methods: {
    finished() {
      let vm = this;
      let securityData = vm.$refs.security_component.getData();
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/archeology/do-save-configuration", {
          s: { catalogs: vm.catalogs, security: securityData },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    updateCulturalSubArea(area) {
      let vm = this;
      let subarea_vls = [];
      let trgtSubArea = vm.catalogs.cultural_subareas.find(
        (n) => n.area_name == area,
      );
      if (trgtSubArea) {
        trgtSubArea.subareas.map((a) => {
          subarea_vls.push({ name: a, value: a });
        });
        window
          .jQuery(vm.$refs.cultural_sub_area_dropdown)
          .dropdown("setup menu", { values: subarea_vls })
          .dropdown({
            onChange(value) {
              let trgt = vm.catalogs.regions.find(
                (n) => n.subarea_name == value,
              );
              if (!trgt) {
                let regions = [];
                vm.temp.region = regions;
                vm.catalogs.regions.push({
                  subarea_name: value,
                  regions: regions,
                });
              } else {
                vm.temp.region = trgt.regions;
                if (value) {
                  vm.updateRegion(value);
                }
              }
            },
          });
      }
    },
    updateRegion(subArea) {
      let vm = this;
      let region_vls = [];
      let trgtRegion = vm.catalogs.regions.find(
        (n) => n.subarea_name == subArea,
      );
      if (trgtRegion) {
        trgtRegion.regions.map((a) => {
          region_vls.push({ name: a, value: a });
        });
        window
          .jQuery(vm.$refs.region_dropdown)
          .dropdown("setup menu", { values: region_vls })
          .dropdown({
            onChange(value) {
              console.log(value);
              let trgt = vm.catalogs.temporality.find(
                (n) => n.region_name == value,
              );
              if (!trgt) {
                let temporality = [];
                vm.temp.temporality = temporality;
                vm.catalogs.temporality.push({
                  region_name: value,
                  temporality: temporality,
                });
              } else vm.temp.temporality = trgt.temporality;
            },
          });
      }
    },
  },
  mounted() {
    window.jQuery(".ui.tabular.menu .item").tab();
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/archeology/do-get-configuration")
      .then((r) => {
        vm.catalogs = r.setup.catalogs;
        if (r.setup.security) {
          vm.$refs.security_component.setData(r.setup.security);
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {
    catalogs() {
      let vm = this;
      let area_vls = vm.catalogs.cultural_area.map((a) => {
        return { name: a, value: a };
      });
      window
        .jQuery(vm.$refs.cultural_area_dropdown)
        .dropdown("setup menu", { values: area_vls })
        .dropdown({
          onChange(value) {
            let trgt = vm.catalogs.cultural_subareas.find(
              (n) => n.area_name == value,
            );
            if (!trgt) {
              let subareas = [];
              vm.temp.cultural_subarea = subareas;
              vm.catalogs.cultural_subareas.push({
                area_name: value,
                subareas: subareas,
              });
            } else {
              vm.temp.cultural_subarea = trgt.subareas;
              if (value) {
                vm.updateCulturalSubArea(value);
              }
            }
          },
        });
    },
  },
  updated: function() {},
};
</script>
